// What an edit screen does while it holds unsaved changes (TGCLOUD-1902,
// rule 5), besides asking on its own close: a reload or a closed browser tab
// asks (beforeunload), and a link out of the pedigree asks too
// (useRouteLeaveGuard reads the registry). Nothing at all while nothing differs.

import { useEffect, useId } from 'react';
import { unloadWithUnsavedWorkAgreed } from 'src/store/workspace/unsavedWork';
import { setUnsavedFormCount } from './unsavedForms';

/**
 * @param {number} count  the form's changed fields (useChangedFields().count)
 */
export default function useUnsavedFormGuard(count) {
  const id = useId();
  const active = Number.isFinite(count) && count > 0;

  useEffect(() => {
    setUnsavedFormCount(id, active ? count : 0);
    return () => setUnsavedFormCount(id, 0);
  }, [id, active, count]);

  useEffect(() => {
    if (!active) return undefined;
    const handler = (event) => {
      // Not a second time for a reload the clinician has already agreed to in
      // the app's own prompt (switching user group).
      if (unloadWithUnsavedWorkAgreed()) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [active]);
}
